export const config = {
  apiUrl: `${process.env.REACT_APP_API_URL}`,
  grpcUrl: `${process.env.REACT_APP_GRPC_URL}`,
};
